import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { doUpload, getRtaUrl } from '../../renderFiles/fileServeDispatch';

const REGRTMARKSTART = /^<ts_htmlEditor.*?>/
const REGRTFID = /^<ts_htmlEditor FID="(.*?)">/
export const MATCHRTMARKSTART = (str) => str && str.match(REGRTMARKSTART) && str.match(REGRTMARKSTART)[0] || RTMARKSTART
export const MATCHTFID = (str) => str && str.match(REGRTFID) && str.match(REGRTFID)[1] || null
export const RTMARKSTART2 = (FID) => FID && FID > 0 && `<ts_htmlEditor FID="${FID}">` || RTMARKSTART
export const RTMARKSTART = '<ts_htmlEditor>'
export const RTMARKEND = '</ts_htmlEditor>'

export const genHtml = value => {
	const isHtml = text => {
		const TAGS = ['<div', '<table']
		text = text.toLowerCase(text)
		for (let tag of TAGS) {
			if (text.includes(tag)) return true
		}
		return false
	}

	return value
		? Array.isArray(value)
			? value.join('<br>')
			: value.startsWith(MATCHRTMARKSTART(value))
				? value.substring(MATCHRTMARKSTART(value).length, value.length - RTMARKEND.length)
				: isHtml(value)
					? value
					: Tyan.utility.newLineToBR(value)//.split('<br>').filter(o => o).join('<br>')
		: value || ''
}

export const doConfirm = (content, onConfirm, onCancel) => {
	let callCancel = true
	const dialogutility = DialogUtility.confirm({
		title: Tyan.t('请确认') || '',
		content: content && Tyan.t(content) || '',
		okButton: {
			text: '确定', icon: 't-fa fa-check', cssClass: 'e-primary',
			click: () => { callCancel = false; dialogutility.hide(), onConfirm && onConfirm() }
		},
		cancelButton: {
			text: '取消', icon: 't-fa fa-times', cssClass: 'e-primary',
			click: () => { callCancel = false; dialogutility.hide(), onCancel && onCancel() }
		},
		close: () => { callCancel && onCnacel && onCancel() },
		closeOnEscape: true,
		animationSettings: { duration: 0 }
	})
}

export const doInsertBR = me => {
	const { richTextEditor: rte, selection } = me

	// const doc = rte.contentModule.getDocument()
	// rte.contentModule.getEditPanel().focus()
	// const range = selection.getRange(doc)
	// const saveSelection = selection.save(range, doc)
	// if (rte.formatter.getUndoRedoStack().length === 0) {
	// 	rte.formatter.saveData();
	// }
	// saveSelection.restore();
	// rte.executeCommand('insertHTML', '<br>')
	// rte.formatter.saveData();
	// rte.formatter.enableUndo(rte);
}

export const goWordEditor = me => {
	const handleSave = ({ html: value }) => {
		const { richTextEditor: rte } = me
		rte.value = value
		// rte.updateValue()
		rte.change && rte.change(rte)
	}

	const handleClose = () => {
		me.richTextEditor.focusIn()
	}

	me.richTextEditor.updateValue()
	Tyan.pubForm.showFrontEditor({
		value: me.richTextEditor.getHtml(),
		onSave: handleSave,
		onClose: handleClose
	})
	me.richTextEditor.focusOut()
}

export const genRTESettings = me => {
	/**
	 * 在rich text editor中插入图片
	 * @param {*} param0 
	 */
	const doInsertImage = ({ file }) => {
		const { richTextEditor: rte, selection } = me

		const onSuccess = ({ Path: path }) => {
			// console.log('success:', `${Tyan.appSettings.fileServerInfo.rtAttachmentDownloadPath}${encodeURIComponent(path)}`)
			// return
			const doc = rte.contentModule.getDocument()
			rte.contentModule.getEditPanel().focus()
			const range = selection.getRange(doc)
			const saveSelection = selection.save(range, doc)
			if (rte.formatter.getUndoRedoStack().length === 0) {
				rte.formatter.saveData();
			}
			saveSelection.restore();
			rte.executeCommand("insertImage", {
				url: getRtaUrl(path), //`${Tyan.appSettings.fileServerInfo.rtAttachmentDownloadPath}${encodeURIComponent(path)}`,
				cssClass: "e-rte-image e-imginline e-resize",
				height: { height: "auto", minHeight: 0, maxHeight: null },
				width: { width: "auto", minWidth: 0, maxWidth: null }
			})
			rte.formatter.saveData();
			rte.formatter.enableUndo(rte);
		}

		const onError = msg => {
			Ext.toast(`${Tyan.t('上传图片失败')}${msg ? `: ${msg}` : ''}`)
			console.log('上传图片失败:', msg)
		}

		const onProgress = percent => {
			console.log('progress:', percent)
		}

		// 检查文件类型
		if (!file || !['image/png', 'image/jpeg'].includes(file.type)) {
			Ext.toast(Tyan.t('请选择图片类型的文件'))
			return
		}
		// uploadToServer = ({ type, blob, onSuccess, onError, onProgress, event, eventData }) => {
		// console.log('doUpload')
		doUpload({ type: 'rt', blob: file, onSuccess, onError, onProgress, })
	}

	const handleToolbarClick = event => {
		const tbtype = event.item.properties.htmlAttributes && event.item.properties.htmlAttributes['data-tbtype']
		if (tbtype === 'image') {
			Tyan.pubForm.getFileInput(([file]) => doInsertImage({ file }), "image/png, image/jpeg")
			me.richTextEditor.contentModule.getEditPanel().focus()
		} else if (tbtype === 'word') {
			goWordEditor(me)
		}
	}

	const handleBlur = () => {
		const range = me.selection.getRange(me.richTextEditor.contentModule.getDocument())
		me.selection.save(range, me.richTextEditor.contentModule.getDocument())
	}

	const handleActionBegin = (event, ...args) => {
		if (event.requestType === 'Image') {
			event.cancel = true
		} else if (event.requestType === 'Paste' && event.originalEvent.clipboardData && event.originalEvent.clipboardData.files[0]) {
			event.cancel = true
			doInsertImage({ file: event.originalEvent.clipboardData.files[0] })
			// 	if(args.type === 'drop' || args.type === 'dragstart') {
			// 		args.cancel =true;
			// }

		} else if (event.type === 'drop' && event.dataTransfer.files && event.dataTransfer.files[0]) {
			doInsertImage({ file: event.dataTransfer.files[0] })
		}
		// console.log('action begin:', event)
		// if (event.requestType === 'Image')
		// 	console.log('action begin:', event)
	}

	/**
	 * 
	 * @param {boolean} overlay 
	 */
	const doOverlayToolbarBtns = overlay => {
		var el
		true && (el = me.richTextEditor.getToolbar().querySelector('.t-btn-image')) && el.classList[overlay ? 'add' : 'remove']('e-overlay')
		true && (el = me.richTextEditor.getToolbar().querySelector('.t-btn-word')) && el.classList[overlay ? 'add' : 'remove']('e-overlay')
	}
	const handleActionComplete = e => {
		var el
		if (e.requestType === 'SourceCode') {
			doOverlayToolbarBtns(true)
		}
		else if (e.requestType === 'Preview') {
			doOverlayToolbarBtns()
		}
	}

	const ret = {
		// settings
		pasteCleanupSettings: {
			prompt: false,
			//deniedAttrs: null,
			allowedStyleProps: [
				"background",
				"background-color",
				"border",
				"border-width",
				"border-color",
				"border-style",
				"border-top",
				"border-bottom",
				"border-left",
				"border-right",
				"border-top-width",
				"border-bottom-width",
				"border-left-width",
				"border-right-width",
				"border-top-color",
				"border-bottom-color",
				"border-left-color",
				"border-right-color",
				"border-top-style",
				"border-bottom-style",
				"border-left-style",
				"border-right-style",
				"clear",
				"visibility",
				"white-space",
				"width",
				"padding",
				"margin",
				"height"
			],
			deniedTags: ["a", "input"],
			keepFormat: true,
			plainText: false
		},

		tableSettings: {
			width: '800px'
		},
		// iframeSettings: {
		// 	// attributes: {
		// 	// 	readonly: 'readonly'
		// 	// },
		// 	// resources: {
		// 	// 	// scripts: ['my-script.js'],
		// 	// 	// styles: ['resources/my-style.css']
		// 	// },
		// 	// enable: true
		// },

		// handlers
		toolbarClick: handleToolbarClick,
		blur: handleBlur,
		actionBegin: handleActionBegin,
		actionComplete: handleActionComplete
	};

	// [
	// 	// 'afterImageDelete',
	// 	// 'beforeDialogClose',
	// 	// 'beforeDialogOpen',
	// 	// 'beforeImageUpload',
	// 	// 'beforeQuickToolbarOpen',
	// 	// 'beforeSanitizeHtml',
	// 	// 'change',
	// 	// 'created',
	// 	// 'destroyed',
	// 	// 'dialogClose',
	// 	// 'dialogOpen',
	// 	// 'focus',
	// 	// 'imageRemoving',
	// 	// 'imageSelected',
	// 	// 'imageUploadFailed',
	// 	// 'imageUploadSuccess',
	// 	// 'imageUploading',
	// 	// 'quickToolbarClose',
	// 	// 'quickToolbarOpen',
	// 	// 'resizeStart',
	// 	// 'resizeStop',
	// 	// 'resizing',
	// ].forEach(name => ret[name] = (...args) => console.log(name, '', args))

	return ret
}